import { useEffect, useState } from "react";
import { getLastSyncAt } from "../api/config";

function relative(d: Date | null): string {
  if (!d) return "waiting…";
  const diff = Math.floor((Date.now() - d.getTime()) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleDateString();
}

export function LiveSyncPill() {
  const [when, setWhen] = useState<Date | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function tick() {
      const d = await getLastSyncAt().catch(() => null);
      if (!cancelled) setWhen(d);
    }
    void tick();
    const t = setInterval(tick, 60_000);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, []);

  return (
    <div className="inline-flex items-center gap-2 bg-accent-soft border border-[#D7E5DE] rounded-full px-3 py-1">
      <span className="w-[7px] h-[7px] rounded-full bg-accent animate-tw-pulse" />
      <span className="text-[11.5px] font-semibold text-accent-text">
        Slack sync live · {relative(when)}
      </span>
    </div>
  );
}
